import React, { useState, useEffect, Fragment } from 'react';
import MasterBar from '../../components/masterBar';
import Card from '../../components/card';
import AtresPieChart from '../../components/charts/atresPieChart';
import TableCompare from '../../components/table';
import Tag from '../../components/tag';
import Tags from '../../components/tags';
import ElTabs from '../../components/elTabs';
import AtresBarChart from '../../components/charts/atresBarChart';
import Autocomplete from '../../components/autocomplete/index';
import BreadCrumb from '../../components/breadCrumb/';
import {
  TYPES,
  SUBTYPES,
  ELECTION_SPAIN_GENERAL_EUROPE
} from '../../envs/core';
import { ResultProvider } from '../../dataProvider/results';
import { getResultOrigin } from '../../dataProvider/origin';
import { getData } from '../../dataProvider/places/single';
import { NearestTownProvider } from '../../dataProvider/places/nearestTown';
import { PlacesProvider } from '../../dataProvider/places';
import HorizontalGraph from '../../components/horizontalGraph';
import './details.scss';

const getRoute = (town, electionNumber, year = 2019) => {
  const host = window.location.hostname.replace('localhost', 'antena3');
  if (host.indexOf('lasexta') !== -1) {
    let currentYear = '';
    if (year !== '2019') {
      currentYear = '/' + year;
    }
    return `https://www.lasexta.com/noticias/nacional/elecciones-municipales/resultados${currentYear}/${electionNumber}${
      town ? town.path : '/comunidad-de-madrid/madrid'
    }`;
  }
  if (host.indexOf('antena3') !== -1) {
    return `https://www.antena3.com/noticias/elecciones/resultados/elecciones-municipales/${year}/${electionNumber}${
      town ? town.path : '/comunidad-de-madrid/madrid'
    }`;
  }
  if (host.indexOf('ondacero') !== -1) {
    let currentYear = '';

    if (year !== '2019') {
      currentYear = '/' + year;
    }
    return `https://www.ondacero.es/noticias/elecciones-municipales-autonomicas/resultados${currentYear ||
      ''}/${electionNumber}${town ? town.path : '/comunidad-de-madrid/madrid'}`;
  }
};

const CustomChart =
  window.location.hostname
    .replace('localhost', 'lasexta')
    .indexOf('lasexta') === -1
    ? AtresPieChart
    : HorizontalGraph;

const MunicipalDetail = ({ match, history }) => {
  const { year, electionNumber, town, reload, masterbar } = match.params;

  const placesIds = ELECTION_SPAIN_GENERAL_EUROPE;
  const type = TYPES.MUNICIPAL;
  const elSubtype = SUBTYPES.SINGLE;

  const [location, setLocation] = useState({});
  const [autocomple, setAutocomple] = useState('');
  const [titleTown, setTitleTown] = useState('');
  const [resultOrigin, setResultOrigin] = useState({});
  const [lastYear, setLastYear] = useState();

  useEffect(() => {
    getData(town).then(place => {
      setLocation(place.location);
      setTitleTown(place.name);
    });
  }, [town]);

  useEffect(() => {
    getResultOrigin(year, type, electionNumber, placesIds)
      .then(historicResult => {
        setResultOrigin(historicResult);
        setLastYear(historicResult.historic.year);
      })
      .catch(err => {});
  }, [year, electionNumber]);

  const goTo = child => {
    if (Boolean(parseInt(reload))) {
      const ruta = getRoute(child, electionNumber, year);
      window.location.href = ruta;
    } else {
      if (child) {
        history.push(
          `/${masterbar}/${reload}/${year}/${electionNumber}/${child.ineId}/detalleMunicipal.html`
        );
      } else {
        history.push(
          `/${masterbar}/${reload}/${year}/${electionNumber}/resultadosmunicipales.html`
        );
      }
    }
  };

  return resultOrigin && resultOrigin.primary ? (
    <ResultProvider
      electionPlace={placesIds}
      year={year}
      active={resultOrigin.primary.active}
      type={type}
      subtype={elSubtype}
      electionNumber={electionNumber}
      placeId={town === 'null' ? null : town}
      details={true}
    >
      {dataResult => (
        <div className="pageDetails pageDetails_Municipales">
          <div className="mainWrapper">
            {Boolean(parseInt(masterbar)) && (
              <MasterBar
                current="municipales"
                history={history}
                reload={reload}
              />
            )}
            <div className="colContainer">
              <div className="floatingBlock left">
                <div className="inner">
                  <BreadCrumb type="MUNICIPALES" onClick={goTo} />
                  <div className="graphContainer">
                    <div className="selectedTownContainer">
                      <span className="selectedTownTitle">{titleTown}</span>
                      <PlacesProvider
                        type="TOWN"
                        name={autocomple}
                        sortby={autocomple ? 'score' : 'name'}
                      >
                        {data => {
                          return (
                            <Autocomplete
                              results={data}
                              onChange={value => setAutocomple(value)}
                              onSelect={select => {
                                goTo(select);
                              }}
                              placeholder={'Seleccione municipio'}
                              showArrow
                            />
                          );
                        }}
                      </PlacesProvider>
                    </div>

                    {dataResult &&
                    dataResult.partiesResult &&
                    town !== 'null' ? (
                      <Fragment>
                        <table className="infoTable">
                          <tbody>
                            <tr>
                              <td className="key">Votos contabilizados: </td>
                              <td className="value votes">
                                {Number(dataResult.totalVotes).toLocaleString(
                                  'es'
                                )}
                              </td>
                              <td className="value votes_percent">
                                {Number(
                                  dataResult.currentCountPercent
                                ).toLocaleString('es') + ' '}
                                %
                              </td>
                            </tr>
                            <tr>
                              <td className="key">Abstenciones: </td>
                              <td className="value votes">
                                {Number(
                                  dataResult.abstentionVotes
                                ).toLocaleString('es')}
                              </td>
                              <td className="value abstention_percent">
                                {Number(
                                  dataResult.abstentionPercent
                                ).toLocaleString('es') + ' '}
                                %
                              </td>
                            </tr>
                            <tr>
                              <td className="key">Votos en blanco: </td>
                              <td className="value whites">
                                {Number(dataResult.whiteVotes).toLocaleString(
                                  'es'
                                )}
                              </td>
                              <td className="value whites_percent">
                                {Number(dataResult.whitePercent).toLocaleString(
                                  'es'
                                ) + ' '}
                                %
                              </td>
                            </tr>
                            <tr>
                              <td className="key">Votos nulos: </td>
                              <td className="value null">
                                {Number(dataResult.invalidVotes).toLocaleString(
                                  'es'
                                )}
                              </td>
                              <td className="value null_percent">
                                {Number(
                                  dataResult.invalidPercent
                                ).toLocaleString('es') + ' '}
                                %
                              </td>
                            </tr>
                            {dataResult.totalSeats && (
                              <tr>
                                <td className="key">Total de concejales: </td>
                                <td className="value votes">
                                  {Number(dataResult.totalSeats).toLocaleString(
                                    'es'
                                  )}
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                        <AtresBarChart
                          label={'Concejales'}
                          labelAbrv={'C.'}
                          data={dataResult.partiesResult || []}
                          dataKey="seats"
                          showLabel={true}
                          seatTotal={dataResult.totalSeats || 0}
                        />
                      </Fragment>
                    ) : (
                      <div>Seleccione una localidad</div>
                    )}
                  </div>
                </div>
              </div>

              <div className="floatingBlock right">
                <div className="inner">
                  <Card
                    title="ESCRUTADO:"
                    titleValue={`${
                      !isNaN(Number(dataResult.currentCountPercent))
                        ? Number(
                            dataResult.currentCountPercent
                          ).toLocaleString()
                        : '0'
                    } %`}
                    subtitle={`Actualizado a las: ${
                      dataResult.updateDate
                        ? dataResult.updateDate.slice(0, -3)
                        : '00:00'
                    }`}
                    className="graphContainer"
                  >
                    <div className="cardSubtitle">
                      <div className="participationTitle">
                        <span className="key">Participación: </span>
                        <span className="value">
                          {!isNaN(Number(dataResult.participationPercent))
                            ? Number(
                                dataResult.participationPercent
                              ).toLocaleString()
                            : '0'}{' '}
                          %
                        </span>
                      </div>
                      <div className="concejalesTitle">
                        <span className="key">Concejales: </span>
                        <span className="value">
                          {!isNaN(Number(dataResult.totalSeats))
                            ? Number(dataResult.totalSeats).toLocaleString()
                            : '0'}
                        </span>
                      </div>
                    </div>
                    <CustomChart
                      data={dataResult.partiesResult || []}
                      leyend={true}
                      label={'Concejales'}
                      labelAbrv={'Conc.'}
                      showFaces={false}
                      showLabel={true}
                      dataKey="seats"
                      seatTotal={dataResult.totalSeats || 0}
                      total={dataResult.totalSeats || 0}
                    />
                  </Card>
                </div>
              </div>

              <div className="floatingBlock right">
                {dataResult && town !== 'null' && (
                  <div className="inner">
                    <ElTabs titles={['Datos', `${lastYear}`]}>
                      <div>
                        {dataResult.partiesResult && (
                          <TableCompare
                            details
                            isCouncilor={true}
                            data={dataResult.partiesResult}
                          />
                        )}
                      </div>
                      <ResultProvider
                        electionPlace={placesIds}
                        active={resultOrigin.historic.active}
                        year={resultOrigin.historic.year}
                        type={type}
                        subtype={elSubtype}
                        electionNumber={electionNumber}
                        placeId={town === 'null' ? null : town}
                        details={true}
                      >
                        {oldData => (
                          <div>
                            {oldData.partiesResult && (
                              <TableCompare
                                details
                                isCouncilor={true}
                                data={oldData.partiesResult}
                              />
                            )}
                          </div>
                        )}
                      </ResultProvider>
                    </ElTabs>
                  </div>
                )}
              </div>

              <div className="floatingBlock left">
                <div className="inner">
                  <Card title="Municipios próximos">
                    <Tags>
                      <NearestTownProvider
                        latitude={location.lat}
                        longitude={location.lon}
                        townId={town}
                      >
                        {data =>
                          data &&
                          data.map(d => (
                            <Tag
                              key={`${d.ineId}-${d.name}`}
                              native={Boolean(parseInt(reload))}
                              route={getRoute(d, electionNumber)}
                              onClick={() => {
                                goTo(d);
                              }}
                            >
                              {d.name}
                            </Tag>
                          ))
                        }
                      </NearestTownProvider>
                    </Tags>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </ResultProvider>
  ) : (
    <div className="loader">Loading</div>
  );
};

export default MunicipalDetail;
